<div class="container">
  <mat-toolbar class="items-aling">
    <span>Copiar</span>
  </mat-toolbar>

  <form [formGroup]="form" (submit)="create(form.value)" appPermissionControl="P264F0001">
    <mat-grid-list [cols]="breakpoint" rowHeight="90px">
      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Origen</mat-label>
            <mat-select formControlName="clave" required appPermissionControl="P264K0001">
              <mat-option
                *ngFor="let item of perfiles"
                [value]="item.clavePerfil"
              >
                {{ item.descripcion }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>
      <mat-grid-tile>
        <ng-container>
          <mat-form-field class="largoFm" color="accent" appearance="outline">
            <mat-label>Destino</mat-label>
            <input
              matInput
              required
              placeholder="123"
              type="text"
              formControlName="descripcion"
            appPermissionControl="P264K0002">
          </mat-form-field>
        </ng-container>
      </mat-grid-tile>
    </mat-grid-list>

    <div mat-dialog-actions>
        <ng-container *ngIf="!loading"
          ><button
            class="botonFm btn-cancel"
            type="button"
            mat-raised-button
            (click)="close()"
           appPermissionControl="P264B0001">
            Cancelar
          </button>
          <button class="botonFm" mat-raised-button color="accent" appPermissionControl="P264B0002">Guardar</button>
        </ng-container>
      </div>
  </form>

 
</div>
